import e, { Component as o } from "react";
import "../../../../node_modules/underscore/modules/index-default.js";
import "../../../../node_modules/underscore/modules/_setup.js";
import "../../../../node_modules/underscore/modules/isFunction.js";
import "../../../../node_modules/underscore/modules/_stringTagBug.js";
import "../../../../node_modules/underscore/modules/isArguments.js";
import r from "../../../../node_modules/underscore/modules/isEqual.js";
import "../../../../node_modules/underscore/modules/isMap.js";
import "../../../../node_modules/underscore/modules/isWeakMap.js";
import "../../../../node_modules/underscore/modules/isSet.js";
import "../../../../node_modules/underscore/modules/underscore.js";
import "../../../../node_modules/underscore/modules/toPath.js";
import "../../../../node_modules/underscore/modules/iteratee.js";
import "../../../../node_modules/underscore/modules/escape.js";
import "../../../../node_modules/underscore/modules/unescape.js";
import "../../../../node_modules/underscore/modules/templateSettings.js";
import "../../../../node_modules/underscore/modules/partial.js";
import "../../../../node_modules/underscore/modules/bind.js";
import "../../../../node_modules/underscore/modules/bindAll.js";
import "../../../../node_modules/underscore/modules/delay.js";
import "../../../../node_modules/underscore/modules/defer.js";
import t from "../../../../node_modules/underscore/modules/throttle.js";
import "../../../../node_modules/underscore/modules/once.js";
import "../../../../node_modules/underscore/modules/invoke.js";
import "../../../../node_modules/underscore/modules/pick.js";
import "../../../../node_modules/underscore/modules/omit.js";
import "../../../../node_modules/underscore/modules/without.js";
import "../../../../node_modules/underscore/modules/union.js";
import "../../../../node_modules/underscore/modules/difference.js";
import "../../../../node_modules/underscore/modules/zip.js";
import "../../../../node_modules/underscore/modules/underscore-array-methods.js";
function n(e, o) {
  (null == o || o > e.length) && (o = e.length);
  for (var r = 0, t = Array(o); r < o; r++) t[r] = e[r];
  return t;
}
function s(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function u(e, o) {
  for (var r = 0; r < o.length; r++) {
    var t = o[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
  }
}
function i(e, o, r) {
  return o in e ? Object.defineProperty(e, o, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = r, e;
}
function l(e) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function c(e, o) {
  return (c = Object.setPrototypeOf || function (e, o) {
    return e.__proto__ = o, e;
  })(e, o);
}
function d(e) {
  return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
}
var a = function a(e) {
    return /^base64/.test(e) ? atob(e.substring(7)) : e;
  },
  p = function p(e) {
    return /[&,\[\]]|^base64:/.test(e) ? "base64:" + btoa(e) : e;
  },
  m = function (o) {
    !function (e, o) {
      if ("function" != typeof o && null !== o) throw TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(o && o.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), o && c(e, o);
    }(y, o);
    var n,
      a,
      m,
      f = (n = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
          o,
          r = l(y);
        if (n) {
          var t = l(this).constructor;
          o = Reflect.construct(r, arguments, t);
        } else o = r.apply(this, arguments);
        return (e = o) && ("object" === d(e) || "function" == typeof e) ? e : s(this);
      });
    function y() {
      var e;
      return !function (e, o) {
        if (!(e instanceof o)) throw TypeError("Cannot call a class as a function");
      }(this, y), e = f.apply(this, arguments), i(s(e), "keys", void 0), e;
    }
    return a = [{
      key: "shouldComponentUpdate",
      value: function value() {
        return !1;
      }
    }, {
      key: "UNSAFE_componentWillMount",
      value: function value() {
        this.replaceUrl = t(this.replaceUrl, this.props.throttle);
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.parseHash();
      }
    }, {
      key: "parseHash",
      value: function value() {
        this.keys = y.parseHash(), this.props.onSet(["query"], this.keys);
      }
    }, {
      key: "serialize",
      value: function value() {
        return encodeURI(Object.keys(this.keys).map(function (e) {
          return "".concat(e, "=").concat(this.keys[e]);
        }.bind(this)).join("&"));
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function value(e) {
        var o;
        if (!r(this.props.watch, e.watch) || e.ignoreFalse !== this.props.ignoreFalse) {
          for (var t in e.watch) switch (void 0 === (o = e.watch[t]) ? "undefined" : d(o)) {
            case "object":
              if (null === o) {
                delete this.keys[t];
                continue;
              }
              if (Array.isArray(o) && !o.reduce(function (e, o) {
                return "object" == typeof o && null !== o;
              }, !1)) {
                this.keys[t] = "[" + o.map(p).join(",") + "]";
                break;
              }
              this.keys[t] = btoa(JSON.stringify(o));
              break;
            case "undefined":
              delete this.keys[t];
              break;
            case "boolean":
              (o || !e.ignoreFalse) && (this.keys[t] = o);
              break;
            default:
              this.keys[t] = p(o.toString());
          }
          this.replaceUrl(document.location.pathname + (this.props.q ? "?" : "#") + this.serialize(), e.watch);
        }
      }
    }, {
      key: "replaceUrl",
      value: function value(e, o) {
        this.props.replaceUrl(e), this.props.onReplaceUrl && this.props.onReplaceUrl(o);
      }
    }, {
      key: "render",
      value: function value() {
        return e.createElement("div", {
          style: {
            display: "none"
          }
        });
      }
    }], u(y.prototype, a), m && u(y, m), y;
  }(o);
i(m, "defaultProps", {
  watch: {},
  throttle: 0,
  replaceUrl: function replaceUrl(e) {
    return history.replaceState({}, null, e);
  },
  ignoreFalse: !1
}), i(m, "getArray", void 0), i(m, "getNum", void 0), i(m, "parseHash", void 0), m.parseHash = function () {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.hash,
    o = e.indexOf("#"),
    r = {};
  return unescape(e).substr(o + 1).split("&").forEach(function (e) {
    if (e) {
      var o,
        t = function (e) {
          if (Array.isArray(e)) return e;
        }(o = e.split(/=(.+)/)) || function (e, o) {
          var r,
            t,
            n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
          if (null != n) {
            var s = [],
              u = !0,
              i = !1;
            try {
              for (n = n.call(e); !(u = (r = n.next()).done) && (s.push(r.value), !o || s.length !== o); u = !0);
            } catch (e) {
              i = !0, t = e;
            } finally {
              try {
                u || null == n.return || n.return();
              } finally {
                if (i) throw t;
              }
            }
            return s;
          }
        }(o, 2) || function (e, o) {
          if (e) {
            if ("string" == typeof e) return n(e, o);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            if ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r) return Array.from(r);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return n(e, o);
          }
        }(o, 2) || function () {
          throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }(),
        s = t[0],
        u = t[1];
      u && (u = "[" === u[0] ? "]" === u[1] ? [] : u.substr(1).slice(0, -1).split(",").map(a) : a(u), r[s] = u);
    }
  }), r;
}, m.getNum = function (e, o) {
  return parseFloat(e.query[o]);
}, m.getArray = function (e, o) {
  var r = e.query[o];
  return r ? r.split(",") : [];
};
export { m as PropsToUrlWatcher };